<template>
  <transition name="a-transition-fade">
    <div class="m-edition-asset-comments-create m-tinymce-comments">
      <AtomAvatarSecondary :userImage="avatarPrimary.image"/>
      <form
        class="m-edition-asset-comments-create-form"
        @submit.prevent=""
      >
        <editor
          v-model="comentario.mensaje"
          :init="tinyMceInit"
        >
        </editor>
        <a
          :class="['display-block margin-top-medium m-edition-asset-comments-create-form-action width-fit-content', comentariosTipo === 1
            ? 'text-link-hover-vidroop'
            : 'text-link-hover-billing']"
          href="#"
          @click.prevent="createContenidoComentario"
        >
          <span v-if="comentariosTipo === 1 && isSendingComment">
            <i class="fas fa-spinner fa-spin"></i>
            {{ $t('mEditionAssetCommentsCreate.actions.sendingComments') }}
          </span>
          <span v-else-if="comentariosTipo === 1 && !isSendingComment">
            {{ $t('mEditionAssetCommentsCreate.actions.sendComments') }}
          </span>

          <span v-if="comentariosTipo === 2 && isSendingComment">
            <i class="fas fa-spinner fa-spin"></i>
            {{ $t('mEditionAssetCommentsCreate.actions.sendingQuestions') }}
          </span>
          <span v-else-if="comentariosTipo === 2 && !isSendingComment">
            {{ $t('mEditionAssetCommentsCreate.actions.sendQuestions') }}
          </span>
        </a>
      </form>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'MoleculeEditionAssetCommentsCreate',

  components: {
    Editor: () => import('@tinymce/tinymce-vue')
  },

  props: {
    comentariosTipo: Number,
    comment: Object,
    contenido: Object,
    tipoComentario: Number
  },

  data () {
    return {
      avatarPrimary: {
        user: '',
        email: '',
        component: '',
        image: ''
      },

      comentario: {
        asunto: '',
        mensaje: '',
        padre: '',
        tipo_comentario: 1
      },

      isSendingComment: false,

      tinyMceInit: {
        branding: false,
        forced_root_block: '',
        force_br_newlines: false,
        force_p_newlines: false,
        height: 170,
        language_url: `/tinymce/js/tinymce/langs/es.js`,
        language: 'es_ES',
        menubar: false,
        placeholder: this.comentariosTipo === 1
          ? this.$t('mEditionAssetCommentsCreate.placeholder.writeComment')
          : this.$t('mEditionAssetCommentsCreate.placeholder.writeAnswer'),

        plugins: [
          'emoticons'
        ],

        statusbar: false,

        toolbar: 'emoticons',
        toolbar_location: 'bottom',
        content_style: 'body, td, pre { color: rgba(0, 0, 0, 0.75); font-family: \'Open Sans\', sans-serif; font-size: 14px; font-weight: 400; line-height: 1.8;}'
      },

      usuario: {}
    }
  },

  computed: {
    setPadre () {
      return this.comment ? this.comment.id : null
    }
  },

  created () {
    this.usuario = this.$store.getters.getUserData
    this.avatarPrimary.image = this.usuario.vidroop_data.avatar
    this.avatarPrimary.user = this.usuario.vidroop_data &&
      this.usuario.vidroop_data.persona &&
      this.usuario.vidroop_data.persona.razon_social
      ? this.usuario.vidroop_data.persona.razon_social
      : this.usuario.email
    this.comentario.tipo_comentario = this.tipoComentario
  },

  methods: {
    createContenidoComentario () {
      if (!this.isSendingComment && this.comentario.mensaje.length) {
        this.isSendingComment = true
        this.comentario.padre = this.setPadre
        this.$services.create('contenido', 'createContenidoComentario', this.comentario, [this.contenido.id, this.$store.getters.getAssetSelectedNode.id, this.comentario.padre])
          .then(response => {
            this.comentario = {
              asunto: '',
              mensaje: '',
              padre: this.comentario.padre,
              tipo_comentario: 1
            }
            this.$modal.updateData()
            this.$emit('showReplies')
            this.$emit('toggleCreate')
            this.isSendingComment = false
          })
          .catch(error => {
            console.log(error)
          })
      }
    }
  }
}
</script>
